export function isEmpty<T>(value: T): boolean {
  return value === undefined || value === null;
}

export function isObject(v: unknown): v is Record<string, unknown> {
  return !!v && typeof v === 'object' && !Array.isArray(v);
}

export function isHttpError(error: unknown): boolean {
  return error instanceof Error && error.name === 'HttpErrorResponse';
}
